// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { reduxForm, Field } from 'redux-form'
import { unitTypes } from 'config/constants'
import { CREATE_NEW_PROJECT } from './constants'
import ProjectType from './ProjectType'
import TextInputWrapper from './TextInputWrapper'
import ProjectConfigWrapper from './ProjectConfigWrapper'

import {
  DefaultContact,
  RadioGroup,
  SubmitErrors,
} from 'components/Form'

import {
  asyncValidate,
  validate,
} from 'validators/newProject'

const idRoot = 'new-project-'

const Form = ({ error, form, handleSubmit }) => (
  <form id={`${idRoot}-form`}>
    <SubmitErrors
      error={error}
      idRoot={'new-project'}
      sourceForm={form} />
    <ProjectType
      idRoot={idRoot}
      sourceForm={form} />
    <TextInputWrapper
      idRoot={'newProjectForm'}
      sourceForm={form} />
    <ProjectConfigWrapper sourceForm={form}>
      <DefaultContact
        idRoot={idRoot}
        sourceForm={form} />
    </ProjectConfigWrapper>
    <Field
      idRoot={`${idRoot}-unit-type`}
      className={'styled-radio radio-rows'}
      component={RadioGroup}
      label={'Unit Type'}
      name={'unitType'}
      options={unitTypes} />
    <div className={'padding-top-1 display-flex center-text justify-content-end'}>
      <button
        className={'btn w-shadow bg-blue hover-inverse'}
        id={'newProjectForm-submit'}
        onClick={handleSubmit}
        type={'submit'}>
        {'Create'}
      </button>
    </div>
  </form>
)

Form.propTypes = {
  error: string,
  form: string.isRequired,
  handleSubmit: func.isRequired,
}

export default reduxForm({
  asyncBlurFields: [
    'serviceContactCode',
  ],
  asyncValidate,
  form: CREATE_NEW_PROJECT,
  validate,
})(Form)
